import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

export const offlineService = {
  /**
   * List offline previews with pagination, search, and status filter
   */
  async getPreviews(params = {}) {
    const { page = 1, limit = 20, status, q } = params;

    const searchParams = new URLSearchParams();
    if (page) searchParams.set('page', String(page));
    if (limit) searchParams.set('limit', String(limit));
    if (status && status !== 'all') searchParams.set('status', status);
    if (q) searchParams.set('q', q);

    const url = `${SERVER_URL}/offline/previews${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

    const response = await fetch(url, {
      headers: authService.getAuthHeaders(),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }

    return response.json();
  },

  /**
   * Create offline order from a preview
   */
  async confirmOrder(previewData, orderType, orderDetails = {}) {
    const url = `${SERVER_URL}/offline/orders`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authService.getAuthHeaders(),
      },
      body: JSON.stringify({
        story_slug: previewData.story_slug,
        kid_name: previewData.kid_name,
        kid_image_url: previewData.kid_image,
        preview_id: previewData.preview_id,
        order_type: orderType,
        ...orderDetails,
      }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }

    return response.json();
  },
};
